import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";


// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>


			{/* <Popup /> */}

			<Slider />


			{/* <div className="container" style={{display:'flex',width:'100%',marginBottom:'25px'}}>
			<div className="col-md-2" style={{background:'orange',color:'maroon',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'0px 0px 15px 15px'}}>
				<h4 style={{fontWeight:'600',color:'maroon'}}>Latest Updates</h4>
			</div>
			<div className="col-md-10" style={{background:'maroon',padding:'5px',borderRadius:'0px 0px 15px 15px',display:'flex',alignItems:'middle'}}>
				<Marquee speed={50} gradient={false} pauseOnHover>
					<div class="news_post_title" style={{padding:'0px'}}><p style={{color:'white',fontSize:'12pt'}}>For enquiries and booking, Contact at +91 471 246 6830</p></div>
				</Marquee>
			</div>
	  </div> */}
			<div class="booking-container">

				{/* <!-- SINGLE DAY --> */}
				<div class="booking-box single">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Online Pooja Booking</h3>
					<p>Single Day & Multi Day Pooja Booking</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.thirunellytemple.in/">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- MULTIPLE DAY --> */}
				<div class="booking-box multiple">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Accommodation</h3>
					<p>Panchatheertham Rest House</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<Link to="Accommodation">
							View Details <span>➜</span>
						</Link>
					</div>

				</div>

				{/* <!-- E-KANIKKA --> */}
				<div class="booking-box ekanikka">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
					</div>
					<h3 className="books-3-ways">Guide for the pilgrims</h3>
					<p>Guide for the pilgrims</p>
					<div class="infobar">
						<span></span>
					</div>
					{/* <div class="book-btn">
						<a href="https://booking.makreritemple.in/Donation.aspx">
							Donate Now <span>➜</span>
						</a>
					</div> */}

				</div>

			</div>
			<div style={{ clear: 'both' }}></div>
			<div className="container" style={{marginTop:'50px'}}>
				<h3>Tenders</h3>
				<div className="row">
					<div className="col-md-4" style={{display:'block !important'}}>
						<a href="./images/qtn.pdf">
							<img src="./images/qtn.png" style={{width:'50%'}} />
							
						</a>
						<a href="./images/qtn.pdf" className="btn btn-primary">View Details</a>
					</div>
					<div className="col-md-4" style={{display:'block !important'}}>
						<a href="./images/qtn_1.pdf">
							<img src="./images/qtn_1.png" style={{width:'50%'}} />
							
						</a>
						<a href="./images/qtn_1.pdf" className="btn btn-primary">View Details</a>
					</div>
				</div>
			</div>
			<div class="container" style={{ marginTop: '100px' }}>
				<div class="row" style={{ backgroundImage: 'url(./images/slider/slider-2.png)', backgroundSize: 'cover', backgroundPosition: 'center', padding: '25px', borderRadius: '25px', backgroundAttachment: 'fixed' }}>

					<div class="col-md-12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '-150px', zIndex: '999' }}>
						<div style={{ height: '350px', width: '350px' }}>
							<img src="./images/twopooja.png" alt="Pooja" style={{ width: '100%' }} />
						</div>

					</div>

					<div style={{ clear: 'both' }}></div>
					<div class="col-md-6">
						<div className="pooja-title">
							<h3 className="text-title">ആയുഷ്കാല പൂജ</h3>
							<p style={{ color: 'maroon', fontFamily: 'anek malayalam', textAlign: 'justify', fontSize: '10pt', fontWeight: '600' }}>
								നിത്യ ജീവിതത്തിൽ ഉണ്ടാകുന്ന ദോഷനിവാരണത്തിനും ദീർഘായുസ്സിനും ആയുരാരോഗ്യത്തിനും നിങ്ങളുടെ ജന്മദിനത്തിൽ എല്ലാവർഷവും ഭഗവത് സന്നിധിയിൽ ചെയ്യുന്ന പൂജ
							</p>
							<a className="btn btn-primary" href="https://booking.thirunellytemple.in/MultidayBookingnew.aspx?Pid=2&Vid=35">Book</a>
						</div>
					</div>
					<div class="col-md-6">
						<div className="pooja-title">
							<h3 className="text-title">പിതൃ പൂജ</h3>
							<p style={{ color: 'maroon', fontFamily: 'anek malayalam', textAlign: 'justify', fontSize: '10pt', fontWeight: '600' }}>
								പരേതാത്മാക്കളുടെ മോക്ഷപ്രാപ്തിക്കും, പിതൃപ്രീതിക്കും ഭഗവത് സന്നിധിയിൽ നടത്തുന്ന പൂജ
							</p>
							<a className="btn btn-primary" href="https://booking.thirunellytemple.in/MultidayBookingnew1.aspx?Pid=1&Vid=29">Book</a>
						</div>
					</div>
				</div>

			</div>

			<div className="row">
				{/* <LatestNews /> */}
			</div>


			<div className="row">

				<div className="col-12 col-md-12" style={{ marginBottom: '0px' }}>

					<div className="container-" >
						<div className="row">
							<div className="col-md-12">
								<div className="frame-">
									<div className="row frame-1">
										<div className="col-md-8 bgwhite">
											<div className="col-md-12" style={{ backgroundAttachment: 'fixed', backgroundPosition: 'center' }}>
												<div className="leftimage">
													{/* <img src="./images/ram.png" /> <br /> */}
													<p className="frame-1-p" style={{ color: 'maroon', borderRadius: '15px', fontSize: '11pt' }}>
														ശംഖചക്ര ഗദാപത്മ <br />
														ധാരിണംമ വനമാലിനം <br />
														നമാമി ദേവദേവേശം <br />
														നാരായണമനാമയം!
													</p>
												</div>
											</div>
											<div className="frontbox">
												{/* <p className="historyheadeg">ഐതിഹ്യം</p> */}
												<p className="frame-1-p">
													വയനാടിന്റെ  ഉത്തരദേശത്ത് കുടകുമലനിരകളോടു ചേർന്ന  ആകാശം മുട്ടെ വ്യാപിച്ചു കിടക്കുന്ന ബ്രഹ്മഗിരിയുടെ താഴ്വരയിൽ  തിരുനെല്ലി ക്ഷേത്രം സ്ഥിതി ചെയ്യുന്നു. മാനന്തവാടിയാണ് തിരുനെല്ലിയുടെ ഏറ്റവും അടുത്തുള്ള ടൗണ്. ഇവിടെ നിന്നും തിരുനെല്ലിയിലേക്കുള്ള ദൂരം 32 കിലോ മീറ്ററാണ്. ഈ റൂട്ടിൽ  ധാരാളം ബസ് സര്വ്വീസുകൾ  ഇന്ന് നിലവിലുണ്ട്. മൈസൂരിലേക്ക് പോകുന്ന പാതയില് കാട്ടിക്കുളം എന്ന സ്ഥലത്തു നിന്നും ഇടത്തോട്ടുതിരിഞ്ഞാൽ  പിന്നെ ക്ഷേത്രത്തിലേക്കുള്ള പാത നിക്ഷിപ്ത വനപ്രദേശങ്ങളിലൂടെയായി. ഇടതൂർന്ന  റോഡിലേക്ക് ചാഞ്ഞു നിൽക്കു ന്ന മുളംകൂട്ടങ്ങൾക്കിടയിൽ  പലപ്പോഴും കാട്ടാനകളെ കാണാം. ഇരുണ്ടുകിടക്കുന്ന വഴിതാരകൾ  താണ്ടിയാൽ  അപ്പപ്പാറ എന്ന സ്ഥലം. തുടർന്ന്  തിരുനെല്ലി പോലീസ് സ്റ്റേഷന്, ഫോറസ്റ്റ് ഡിപ്പാര്ട്ടുമെന്റിന്റെ ബംഗ്ലാവ്. ഒടുവിൽ  ബ്രഹ്മഗിരിയുടെ തണലിൽ  സ്ഥിതി ചെയ്യുന്ന പുരാണപ്രസിദ്ധമായ തിരുനെല്ലിക്ഷേത്രം. കാറ്റ് മാത്രം കടന്നുചെല്ലുന്ന വനഭൂമിക്കു നടുവിൽ  ഏതു കാലത്തെന്നു പറയുവാൻ  കഴിയാത്ത അത്രയും പഴക്കമാർന്ന  ഭാരതത്തിലെ പുണ്യക്ഷേത്രങ്ങളിലൊന്ന്. ഇവിടെ സ്ഥിതിയുടെ കർത്താവായ  മഹാവിഷ്ണുവിന്റെയൂം, സൃഷ്ടിയുടെ ദേവനായ ബ്രഹ്മാവിന്റെയും ചൈതന്യധാരകളും, പ്രകൃതിയുടെ മനോഹാരിതയും ഒത്തുചേര്ന്നു പരിലസിക്കുന്നു. ഈ പുണ്ണ്യ ഭൂമിയിലാണ് മോക്ഷദായിനിയായി പാപനാശിനി ഒഴുകുന്നത്. ജമദ്ഗ്നി മഹർഷി  തൊട്ട് എത്രയോ പുണ്യാത്മാക്കള്ക്ക് മോക്ഷശിലയായ വിശ്രുതമായ പിണ്ണപ്പാറയുള്ളത് പാപനാശിനിയാലാണ്. ബ്രഹ്മഗിരിയിലെ വിടെയോ പാപനാശിനി പിറവിയെടുക്കുന്നു. പാപനാശിനി കാളിന്ദിയി ലാണ് ലയിക്കുന്നത്. ബ്രഹ്മാവിന്റെ പാദസ്പര്ശാനുഗ്രഹം സിദ്ധിച്ചതിൽ  ബ്രഹ്മഗിരി എന്ന പേരില് ഈ പർവ്വത നിര  പ്രസിദ്ധമായി. ബ്രഹ്മഗിരിയിലെ ദുർഗമമായ  വനാന്തരങ്ങളിൽ പക്ഷിപാതാളം, ഗരുഡപ്പാറ, ഭൂതത്താന്കുന്ന് തുടങ്ങിയ സ്ഥലങ്ങൾ  സാഹസികരെ ആകർഷിക്കുന്നു . ഇതാണ് തിരുനെല്ലി. ഐതീഹ്യങ്ങളിലും പുരാണങ്ങളിലും വിളങ്ങിനില്ക്കുന്ന പുണ്യഭൂമി. ഒരു വാക്കുകൂടി: തിരുനെല്ലിക്ഷേത്രത്തെക്കുറിച്ചു കിട്ടിയ അറിവുകൾ  പരിമിതങ്ങളാണ്. പുരാതനരേഖകളൊന്നും ദേവസത്തിന്റെ കൈവശമില്ല. ഇവിടെ പകർത്തുന്ന  വിവരങ്ങൾ  അധികവും വാമൊഴികളായി തലമുറകൾ  കൈമാറി വന്ന അറിവു മാത്രമാണ് തിരുനെല്ലി.
												</p>

												{/* <Link to="/Ithihyam" className="btn btn-warning pos">Read More</Link> */}
												<div class="col-md-12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: '999' }}>
													<div style={{ height: '350px', width: '350px' }}>
														<img src="./images/twopooja.png" alt="Pooja" style={{ width: '100%' }} />
													</div>
													<div class="botton">
														<h3 style={{fontWeight:'600'}}>Darsan Timings</h3>
														<p style={{fontWeight:'600',color:'black'}}>Morning - 5:30 AM – 12:30 PM (Noon)</p>
														<p style={{ fontWeight:'600',color:'black',marginTop: '-20px' }}>Evening - 5:30 PM – 8 PM</p>
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-4 bgwhite" style={{padding:'80px'}}>
											<div className="container">
												<div className="row">
													<div className="col-md-12">
														<div className="row">
															<div className="col-md-12 box-images" style={{ backgroundImage: 'url(./images/ammakkavu.jpg)' }}>
																<div className="boxes-4" >
																	{/* <img src="./images/ammakkavu.jpg" alt="ammakkavu"  style={{width:'100%'}} /> */}
																	<h3 className="title-text">Ammakkavu</h3>
																	<h3 className="title-text">അമ്മക്കാവ്</h3>
																</div>
															</div>
															<div className="col-md-12 box-images" style={{ backgroundImage: 'url(./images/mechilatt.jpg)' }}>
																<div className="boxes-4">
																	<h3 className="title-text">Mechhilaat</h3>
																	<h3 className="title-text">മേച്ചിലാട്ട്</h3>
																	{/* <h3>Ammakkavu</h3> */}
																</div>
															</div>
															<div className="col-md-12 box-images" style={{ backgroundImage: 'url(./images/thenvarambu.jpg)' }}>
																<div className="boxes-4">
																	<h3 className="title-text">Thenavarambu</h3>
																	<h3 className="title-text">തേൻവരമ്പ്‌</h3>
																	{/* <h3>Ammakkavu</h3> */}
																</div>
															</div>
															<div className="col-md-12 box-images" style={{ backgroundImage: 'url(./images/vendol.jpg)' }}>
																<div className="boxes-4">
																	<h3 className="title-text">Vendol Kshethram</h3>
																	<h3 className="title-text">വേണ്ടോൽ</h3>
																	{/* <h3>Ammakkavu</h3> */}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>


						</div>
					</div>


				</div>

			</div>
		</div>

	);
}

export default Home;